import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { GenerateCaptionRequest } from "./dtos";

const AI_CAPTION_SERVICE = `${Constants.API_URL}/bedrock/ai_captions`;

/** The Share flow writes a review caption here before any design is rendered, so the post never waits on it. */
export class AiCaptionServices {
  @scCatchServiceException(true)
  static async generate(request: GenerateCaptionRequest): Promise<{ caption: string }> {
    const { data } = await axios.post<{ caption: string }>(`${AI_CAPTION_SERVICE}/generate`, request);
    return data;
  }
}
